import React from 'react';
import AceEditor, { IAceEditorProps } from 'react-ace';

// TODO skip absolute imports or configure `import-sorter.json` to ignore `ace-builds`
// bc these imports need to be placed after importing `react-ace`
import 'ace-builds/src-noconflict/mode-liquid';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/mode-javascript';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    root: {
      // the editor has only support for monospaced fonts.
      '& > div': {
        fontFamily: 'Fira code, Consolas, monospace',
        fontWeight: 400,
      },
    },
  });

const linesDefault = 8;

export interface CodeEditorProps extends IAceEditorProps, WithStyles<typeof styles> {}

const CodeEditor: React.FC<CodeEditorProps> = ({ classes, mode = '', ...rest }) => (
  <AceEditor
    className={classes.root}
    width={'100%'}
    mode={mode || 'liquid'}
    theme="tomorrow"
    editorProps={{ $blockScrolling: true }}
    wrapEnabled
    minLines={linesDefault}
    maxLines={30}
    highlightActiveLine={false}
    showGutter={false}
    fontSize={14}
    setOptions={{
      tabSize: 2,
      highlightSelectedWord: true,
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      enableSnippets: true,
    }}
    showPrintMargin={false}
    cursorStart={1}
    {...rest}
  />
);

export default withStyles(styles)(CodeEditor);
